// extracted by mini-css-extract-plugin
export default {"messageCtn":"MessageDisplay_messageCtn__LSu01","messageHeader":"MessageDisplay_messageHeader__0S7vS","messageBody":"MessageDisplay_messageBody__Go2F8"};